var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    rx: 21.5,
    fill: "url(#paint0_linear_383_2415)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 16.554V26.446C17 28.0052 18.7051 28.9648 20.038 28.1555L28.1842 23.2096C29.467 22.4308 29.467 20.5692 28.1842 19.7904L20.038 14.8445C18.7051 14.0352 17 14.9948 17 16.554Z",
    fill: "#08090B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_383_2415",
    x1: 0,
    y1: 21.5,
    x2: 43,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6C67C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A58447"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/Play Button.4bfa2a39594e6350741a7cab6301b978.svg";
export { ForwardRef as ReactComponent };